import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICreateBusinessPartnerEmail } from './interfaces/create-business-partner-email.interface';
import { EMAIL_TYPE_OPTIONS } from 'app/shared/constants/email-list.constant';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { HasPermissionPipe, PermissionDirective, PermissionService } from "app/core/permission";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";
import { COMPANY_EMBEDDED_CONTACT_DATA_PERMISSIONS } from "app/common/constants/permission";

@Component({
  selector: 'app-add-business-partner-email-modal',
  styleUrl: './business-partner-email.component.scss',
  templateUrl: './business-partner-email.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    PermissionDirective,
    HasPermissionPipe,
  ],
})
export class AddBusinessPartnerEmailComponent implements OnInit {
  createForm!: FormGroup;
  isEditMode = false;

  typeOptions = EMAIL_TYPE_OPTIONS;
  
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddBusinessPartnerEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICreateBusinessPartnerEmail | null,
    private readonly permissionService: PermissionService,
    private readonly handlerMessage: HandlerMessageService
  ) {}

  ngOnInit(): void {
    this.isEditMode = !!this.data;

    this.createForm = this.fb.group({
      _id: this.data?._id,
      email: [
        this.data?.email || '',
        [Validators.required,
         Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)],
      ],
      isPrincipal: [this.data?.isPrincipal || false],
      type: [this.data?.type || null]
    });
  }

  save(): void {
    if (this.createForm.invalid) {
      this.createForm.markAllAsTouched();
      return;
    }

    const dataToSend = this.createForm.value;
    this.dialogRef.close(dataToSend);
  }

  checkIfHasPermission(permission: string, errorMessage?: string): boolean {
    const hasPermission = this.permissionService.has(permission);

    if (!hasPermission && errorMessage) {
      this.handlerMessage.error({ message: errorMessage });
    }

    return hasPermission;
  }
}
